import httpClient from './httpClient'

const AdvertiserApi = {
  async fetchAdvertiserList(minPermissionLevel) {
    try {
      const res = await httpClient.get('/advertiser', { minPermissionLevel })
      return res.data
    } catch (e) {
      console.log(e, 'error of AdvertiserApi.fetchAdvertiserList')
      throw e
    }
  },
  async fetchAdvertiserSearchList(
    minPermissionLevel,
    keyword,
    status,
    pageSize,
    pageNo,
  ) {
    if (status === null) {
      return { items: [], count: 0, pageNo: 1 }
    }
    try {
      var url = `/advertiser?page_size=${pageSize}&page_no=${pageNo}`
      if (keyword) {
        url = url + `&keyword=${keyword}`
      }
      if (status) {
        url = url + `&status=${status}`
      }
      const res = await httpClient.get(url, { minPermissionLevel })
      return res.data
    } catch (e) {
      console.log(e, 'error of AdvertiserApi.fetchAdvertiserSearchList')
      throw e
    }
  },
  async fetchAdvertiser(advertiserId) {
    try {
      const res = await httpClient.get(`/advertiser/${advertiserId}`)
      return res.data
    } catch (e) {
      console.log(e, 'error of AdvertiserApi.fetchAdvertiserList')
      throw e
    }
  },
  async addAdvertiser(body) {
    try {
      return await httpClient.post('/advertiser', body)
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async editAdvertiser(id, body) {
    try {
      return await httpClient.put(`/advertiser/${id}`, body)
    } catch (e) {
      console.log(e)
      throw e
    }
  },
  async deleteAdvertiser(id) {
    try {
      return await httpClient.delete(`/advertiser/${id}`)
    } catch (e) {
      console.log(e)
      throw e
    }
  },

  async searchAdvertiser({
    keyword,
    minPermissionLevel,
    advertiserStatuses = ['active', 'inactive'],
    pageNo,
    pageSize,
    sortKey,
    sortDirection,
  }) {
    if (advertiserStatuses.length === 0)
      return { items: [], count: 0, pageNo: 1 }
    const status = (() => {
      if (
        advertiserStatuses.includes('active') &&
        advertiserStatuses.includes('inactive')
      )
        return undefined
      if (
        advertiserStatuses.includes('active') ||
        advertiserStatuses.includes('inactive')
      )
        return advertiserStatuses[0]
      return undefined
    })()
    const reqBody = {
      query: {
        keyword,
        minPermissionLevel,
        status,
      },
      sortKey,
      sortDirection,
    }
    try {
      if (pageNo === undefined && pageSize === undefined) {
        const res = await httpClient.post(`/advertiser/search/all`, {
          ...reqBody,
        })
        return res.data
      }
      const res = await httpClient.post(`/advertiser/search`, {
        ...reqBody,
        pageNo,
        pageSize,
      })
      return res.data
    } catch (e) {
      console.log(e, 'error of searchAdvertiser')
      throw e
    }
  },

  async getAdvertiserAccountList({ advertiserId, minPermissionLevel }) {
    const params = { permission: minPermissionLevel }
    try {
      const res = await httpClient.get(`/advertiser/${advertiserId}/account`, {
        params,
      })
      return res.data
    } catch (e) {
      console.log(e, 'error of getAdvertiserAccount')
      throw e
    }
  },

  /**
   * 広告主配下の配信先リスト一覧取得
   */
  async getTargetingInventoryList(advertiserId, params) {
    try {
      const res = await httpClient.get(
        `/advertiser/${advertiserId}/managed/targeting/inventory_list`,
        {
          params: params,
        },
      )
      return res.data
    } catch (e) {
      console.log(e, 'error of fetchInventoryTargetingListAdvertiser')
      throw e
    }
  },
}

export default AdvertiserApi
